import React, { forwardRef, useCallback, useEffect, useState } from 'react'
import { Header, Page } from 'components'
import {
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
  Divider,
} from '@material-ui/core'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import MaterialTable from 'material-table'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import LastPageIcon from '@material-ui/icons/LastPage'
import SettingsIcon from '@material-ui/icons/Settings'
import { useReportService } from 'hooks/useReportService'
import { BackButton } from 'components/BackButton/BackButton'
import { Espelho } from 'components/Espelho'
import { DetailPanel } from './Components/DetailPanel'
import { useAuth } from 'hooks/useAuth'
import useRouter from 'utils/useRouter'

import useStyles from './styles'
import constants from 'utils/constants'

export const GerenciarReport = (props) => {
  const { route } = props
  const router = useRouter()
  const classes = useStyles()
  const reportService = useReportService()
  moment.locale('pt-br', localization)
  const [report, setReport] = useState([])
  const [reportAtual, setReportAtual] = useState(null)
  const [processandoReport, setProcessandoReport] = useState(false)
  const [abrirEspelho, setAbrirEspelho] = useState(false)
  const [statusAtual, setStatusAtual] = useState(null)
  const { permissoesUsuario, verificarPermissao } = useAuth()

  useEffect(() => {

    if (permissoesUsuario?.length) {
      if(!verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA])) {
        router.history.push(`/`)
      }
    }
  }, [permissoesUsuario])

  const fetchListarReports = useCallback(async () => {
    const response = await reportService.listarReportsAsync(setProcessandoReport)
    setReport(response)
    
  }, [])

  useEffect(() => {
    fetchListarReports()
    
  }, [fetchListarReports])

  useEffect(() => {
    if (reportAtual?.id) {
      setStatusAtual(reportAtual.status)
    }
  }, [reportAtual])

  const handleOpenEspelho = (rowData) => {
    setAbrirEspelho(true)
    setReportAtual(rowData)
  }

  const handleConfirmar = async () => {
    await reportService.gerenciarReport(reportAtual.id, { statusAtual }, setProcessandoReport)
    fetchListarReports()
    setAbrirEspelho(false)
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <Card className={classes.results}>
        <CardContent>
          <Grid alignItems="flex-end" container justifyContent="space-between" spacing={3}>
            <Grid item>
              <Typography className={classes.pageTitle}>
                <b>Feedbacks registrados</b>
              </Typography>
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
                <Divider />
              </Grid>
            <Grid item>
              <BackButton />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <MaterialTable
              title=""
              localization={{
                body: {
                  emptyDataSourceMessage: processandoReport ? (
                    <CircularProgress disableShrink />
                  ) : (
                    'Nenhum feedback cadastrado'
                  ),
                  filterRow: {
                    filterTooltip: 'Filtro',
                  },
                },
                header: {
                  actions: 'Gerenciar Status',
                },
              }}
              detailPanel={(rowData) => <DetailPanel idReportSelecionado={rowData.id} />}
              onRowClick={(event, rowData, togglePanel) => togglePanel()}
              data={report}
              columns={[
                {
                  title: 'Usuário',
                  render: (rowData) => rowData.usuRep?.nome,
                },
                {
                  title: 'Tipo de Feedback',
                  render: (rowData) => rowData.tipo_report,
                },
                {
                  title: 'Status',
                  render: (rowData) => rowData.status,
                },
              ]}
              options={{
                actionsColumnIndex: -1,
                search: false,
                pageSize: 20,

                headerStyle: {
                  backgroundColor: '#f4f6f8',
                },
                toolbar: false,
              }}
              actions={[
                {
                  icon: SettingsIcon,
                  tooltip: 'Gerenciar Status',
                  onClick: (event, rowData) => handleOpenEspelho(rowData),
                },
              ]}
              icons={{
                SortArrow: forwardRef((propsSortArrow, ref) => (
                  <ArrowDownwardIcon {...propsSortArrow} ref={ref} />
                )),
                NextPage: forwardRef((propsNextPage, ref) => (
                  <NavigateNextIcon {...propsNextPage} ref={ref} />
                )),
                DetailPanel: forwardRef((propsNextPage, ref) => (
                  <NavigateNextIcon {...propsNextPage} ref={ref} />
                )),
                PreviousPage: forwardRef((propsPreviousPage, ref) => (
                  <NavigateBeforeIcon {...propsPreviousPage} ref={ref} />
                )),
                FirstPage: forwardRef((propsFirstPage, ref) => (
                  <FirstPageIcon {...propsFirstPage} ref={ref} />
                )),
                LastPage: forwardRef((propsLastPage, ref) => (
                  <LastPageIcon {...propsLastPage} ref={ref} />
                )),
              }}
              style={{
                padding: '16px',
                fontSize: '13px',
                textAlign: 'left',
                fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                fontWeight: '400',
                lineHeight: '21px',

                letterSpacing: '-0.05px',
                verticalAlign: 'inherit',
              }}
            />
          </Grid>
        </CardContent>
        <Espelho
          aberto={abrirEspelho}
          setAberto={setAbrirEspelho}
          handleConfirmar={handleConfirmar}
          processando={processandoReport}
          titulo="Alteração do Status do Feedback"
        >
          <Grid item md={12} sm={12} xs={12}>
            <FormControl>
              <Typography>Deseja o status atual para qual?</Typography>
              <Select
                defaultValue={statusAtual || 'A'}
                value={statusAtual || null}
                onChange={(e) => setStatusAtual(e.target.value)}
              >
                <MenuItem value="Em aberto">Em aberto</MenuItem>
                <MenuItem value="Analisando">Analisando</MenuItem>
                <MenuItem value="Concluído">Concluído</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Espelho>
      </Card>
    </Page>
  )
}
